import { PERMISSIONS_OPTIONS_VALUE } from 'constants/team-members';

const { VIEW_ONLY } = PERMISSIONS_OPTIONS_VALUE;

export const SETTINGS_PERMISSIONS = {
  [VIEW_ONLY]: {
    HIDE_EDIT_PERSONAL_INFO: true,
    HIDE_DELETE_ACCOUNT_SECTION: true,
    DIM_BUSINESS_INFO_FIELDS: true,
    HIDE_ACCOUNT_TYPE_SECTION: true,
    HIDE_REST_AND_SAVE: true,
    HIDE_LOCATIONS_ACTIONS: true
  }
};
